<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-text v-if="isLoaded">
            <div class="row" v-if="hasEnabledTenants">
              <div v-if="hasEnabledBle">
                <v-tabs v-model="activeTab" grow slider-color="primary">
                  <v-tab href="#owner" active-class="tabs__item--active dps-tab-selected"> {{ $t('private_tenant_title_owner') }} </v-tab>
                  <v-tab href="#tenantInvitations" active-class="tabs__item--active dps-tab-selected"> {{ $t('private_tenant_title_invites') }} </v-tab>
                </v-tabs>
                <v-tabs-items v-model="activeTab">
                  <v-tab-item value="owner">
                    <owners :parkingData="this.parking"></owners>
                  </v-tab-item>
                  <v-tab-item value="tenantInvitations">
                    <tenant-invitations></tenant-invitations>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>

            <div v-if="!hasEnabledBle">
              <owners :parkingData="this.parking"></owners>
            </div>

            <div class="col-md-12" v-if="!hasEnabledTenants">
              <div class="panel">
                <div class="panel-body">
                  <div id="noTennantsData" class="dataTables_empty coming-soon">
                    <div class="space-30"></div>
                    <div
                      class="col-sm-8 col-sm-offset-1 wow animated bounceIn animated"
                      data-wow-delay="0.4s"
                      style="visibility: visible; animation-delay: 0.4s; animation-name: bounceIn;"
                    >
                      <h1 v-html="$t('private_parking_tenants_title')"></h1>
                      <p class="subtitle">
                        <span v-html="$t('private_parking_tenants_subtitle')"></span>
                        <br />
                        <span v-html="$t('private_parking_tenants_follow')"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import Owners from '@/components/parking/Owners';
import TenantInvitations from '@/components/parking/TenantInvitations';
import store from '@/store';
import keys from '@/store/keys';
import _ from 'lodash';
import parkingService from '@/services/parkingService';

export default {
  name: 'ParkingTenant',
  components: { Owners, TenantInvitations },
  computed: {
    hasEnabledTenants() {
      return this.parking != null && this.parking.hasWhitelist === true;
    },
    hasEnabledBle() {
      return this.parking != null && this.parking.hasBLE === true;
    }
  },
  data() {
    return {
      parkingId: this.$route.params.id,
      parking: null,
      isLoaded: false,
      activeTab: 'owner'
    };
  },
  created() {
    // if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected.id) {
    // this.parking = store.state.parkingSelected;
    // }

    this.loadParking();

    EventBus.$on(keys.eventOnLanguageChanged, this.updateTableLables);
    EventBus.$on(keys.eventOnTenantInvitationCreated, this.goToInvitationTab);
  },

  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
    EventBus.$off(keys.eventOnTenantInvitationCreated);
  },

  methods: {
    loadParking() {
      this.isLoaded = false;
      let params = {
        parking: this.parkingId
      };
      parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
    },
    goToInvitationTab() {
      this.activeTab = 'tenantInvitations';
    },
    summarySuccessHandler(data) {
      this.parking = data;
      store.commit('UPDATE_PARKING_SELECTED', this.parking);
      this.isLoaded = true;
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    },
    updateTableLables() {
      _.each(this.headers, itHeaders => {
        itHeaders.text = this.$i18n.t(itHeaders.i18nText);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/parking/Tenants.vue